import Vue from "vue";
import Vuex from "vuex";

import router from "../router";
import { getUserDataLocal, setUserDataLocal, deleteUserDataLocal } from "../db_save";

Vue.use(Vuex);

import store from "./index";

export default new Vuex.Store({
	state: {
		need_tabs: false,
		nombreVista: "",
		user_data: getUserDataLocal()
	},
	mutations: {
		//ACTUALIZAR NOMBRE DE VISTA
		setNombreVista(state, payload) {
			state.nombreVista = payload;
		},
		//SET DATOS DEL USUARIO POR LOGIN
		loginUser(state, payload) {
			state.user_data = payload;
		},
		//BORRAR DATOS
		logoutUser(state) {
			state.user_data = null;
		},
		//CAMBIAR USO DE TABS
		toggleTabs(state, payload) {
			state.need_tabs = payload;
		},
		disableNew(state) {
			state.user_data.isNew = false;
		}
	},
	actions: {
		iniciarSesionUsuario({ commit }, payload) {
			let data = payload.providerData[0];
			//let token = payload.refreshToken;

			let user = {
				data,
				isNew: payload.metadata.lastSignInTime == payload.metadata.creationTime
			};
			setUserDataLocal(data);
			commit("loginUser", user);

			router.push({ name: "Inicio" });
		},
		cerrarSesionUsuario({ commit }) {
			commit("logoutUser");
			deleteUserDataLocal();
			router.push({ name: "Login" });
		}
	},
	getters: {
		isMenuView: state => {
			return state.nombreVista == "CENTRO+" ? true : false;
		},
		isPrimeraVez: state => {
			if (state.user_data) {
				let isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
				let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

				if (isSafari && iOS && !("Notification" in window)) {
					//console.log("USANDO IOS or Safari");
					return false;
				} else {
					if (state.user_data.isNew && state.nombreVista == "CENTRO+") {
						store.commit("disableNew");

						return true;
					} else {
						return false;
					}
				}
			}
		}
	},
	modules: {}
});
